import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import useWindowSize from '../hooks/windowSize.js';
import NavigationSideBar from './NavigationSideBar.js';
import StateContext from '../contexts/state.js';

import '../styles/pageLayout.css';

const getHeaderHeight = () => {
    const siteHeader = document?.querySelector(".header");
    if(!siteHeader) {
        return 0;
    }
    return siteHeader.offsetHeight;
};

const PageLayout = ({ children = [], footer = null }) => {
    const location = useLocation();
    const size = useWindowSize();
    const { state } = useContext(StateContext);

    const [isMobile, setIsMobile] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        setHeaderHeight(getHeaderHeight());
        setIsMobile(size.width < 768);
    }, [children, location, size]);

    return (
        <div className="container">
            <div
                className="page-layout"
                style={{
                    '--header-height': `${headerHeight}px`
                }}
            >
                <div className="page-layout--main">
                    <div className="page-layout--nav">
                        <NavigationSideBar />
                    </div>
                    <div className="page-layout--banner">
                        { state?.banner }
                    </div>
                    <div className="page-layout--content">
                        { children }
                    </div>
                </div>
                <div className="page-layout--footer">
                    { footer }
                </div>
            </div>
        </div>
    );
};

export default PageLayout;
